import { ENV_CONFIG } from './environment';

// API Configuration (getters: BASE_URL reflecte VITE em tempo de execução)
export const API_CONFIG = {
  get BASE_URL() {
    return ENV_CONFIG.API_URL;
  },
  get GEMINI_API_KEY() {
    return ENV_CONFIG.GEMINI_API_KEY;
  },
};

// API Endpoints
export const API_ENDPOINTS = {
  // Auth
  LOGIN: '/api/auth/login/',
  REGISTER: '/api/auth/register/',
  REFRESH_TOKEN: '/api/auth/token/refresh/',
  VERIFY_EMAIL: '/api/auth/verify-email/',
  RESEND_VERIFICATION_EMAIL: '/api/auth/resend-verification-email/',
  PASSWORD_RESET: '/api/auth/password-reset/',
  PASSWORD_RESET_CONFIRM: '/api/auth/password-reset-confirm/',
  CHANGE_PASSWORD: '/api/auth/change-password/',
  USER_PROFILE: '/api/auth/user/',
  USER_PROFILE_DETAIL: '/api/auth/users/profile/',
  USER_PROFILE_UPDATE: '/api/auth/users/update_profile/',
  
  // Payments
  SUBSCRIPTIONS: '/api/payments/subscriptions/',
  PLANS: '/api/payments/plans/',
  PLANS_WITH_SUBSCRIPTION: '/api/payments/plans/with-subscription/',
  UPGRADE: '/api/payments/upgrade/',
  CANCEL_SUBSCRIPTION: '/api/payments/cancel-subscription/',
  DELETE_ACCOUNT: '/api/payments/delete-account/',
  CREATE_CHECKOUT_SESSION: '/api/payments/create-checkout-session/',
  USAGE_SUMMARY: '/api/payments/usage/summary/',
  
  // API Keys
  PROVIDERS: '/api/apikey/providers/',
  ACTIVE_PROVIDERS: '/api/apikey/providers/active/',
  
  // General
  HEALTH: '/api/health/',
  AGENTS: '/api/agents/',
  
  // Support Messages
  SUPPORT_MESSAGES: '/api/support/messages/',
  SUPPORT_MESSAGES_CREATE: '/api/support/messages/create/',
  SUPPORT_MESSAGE_DETAIL: '/api/support/messages/',
  SUPPORT_MESSAGE_UPDATE: '/api/support/messages/',
  SUPPORT_MESSAGE_RESPOND: '/api/support/messages/',
  SUPPORT_CATEGORIES: '/api/support/categories/',
  SUPPORT_NOTIFICATIONS: '/api/support/notifications/',
  SUPPORT_NOTIFICATIONS_UNREAD_COUNT: '/api/support/notifications/unread-count/',
};
